module.exports = __webpack_public_path__ + "img/wy3.46809a4d.png";